import {scaleLinear} from 'd3-scale';

export const isSiteInDarkMod = () => {
  const el = document.querySelector('html[data-theme]');

  if (el) {
    const {theme} = el.dataset;

    if (theme) {
      return theme === 'dark';
    }
  }
  return false;
};

export const getRcpItemsByRcpFilter = (rcpSelectedItems) => {
  let rcp26Graph = null;
  let rcp45Graph = null;
  let rcp85Graph = null;

  if (rcpSelectedItems.length > 0) {
    rcp26Graph = rcpSelectedItems.find((element) => element === 'rcp26_graph');
    rcp45Graph = rcpSelectedItems.find((element) => element === 'rcp45_graph');
    rcp85Graph = rcpSelectedItems.find((element) => element === 'rcp85_graph');
  }

  return {
    rcp26Graph,
    rcp45Graph,
    rcp85Graph,
  };
};

export const getChartSize = (chartWrapper, labelAxis) => {
  let marginTop = 0;
  let marginRight = 0;
  let marginBottom = 0;
  let marginLeft = 0;

  if (chartWrapper) {
    const svg = chartWrapper.querySelector('svg');

    if (svg) {
      const style = window.getComputedStyle(svg, null);

      marginTop = parseInt(style.marginTop, 10);
      marginRight = parseInt(style.marginRight, 10);
      marginBottom = parseInt(style.marginBottom, 10);
      marginLeft = parseInt(style.marginLeft, 10);
    }
  }
  let chartWidth = chartWrapper
    ? chartWrapper.offsetWidth - (marginLeft + marginRight)
    : null;
  chartWidth -= labelAxis ? labelAxis.clientWidth + 20 : 0;

  return {
    width: chartWidth,
    height: chartWidth
      ? Math.round(chartWidth * 0.5) - (marginTop + marginBottom)
      : null,
  };
};

export const getThemeSwitcher = (themeSwitchHandler) => {
  const items = document.querySelectorAll('.theme-switcher');

  return {
    addEventListener: () => {
      items.forEach((item) => {
        item.addEventListener('click', themeSwitchHandler);
      });
    },
    removeEventListener: () => {
      items.forEach((item) => {
        item.removeEventListener('click', themeSwitchHandler);
      });
    },
  };
};

export const getBoundariesRcpData = (data) => {
  let globalMinimum = data.rcp26.entries[0].min;
  let globalMaximum = data.rcp26.entries[0].max;

  for (const [key, rcpArray] of Object.entries(data)) {
    const minimum = rcpArray.entries.reduce(
      (min, element) => (element.min < min ? element.min : min),
      rcpArray.entries[0].min
    );
    const maximum = rcpArray.entries.reduce(
      (max, element) => (element.max > max ? element.max : max),
      rcpArray.entries[0].max
    );
    globalMinimum = minimum < globalMinimum ? minimum : globalMinimum;
    globalMaximum = maximum > globalMaximum ? maximum : globalMaximum;
  }

  const diffMaxMin = 0.2 * (globalMaximum - globalMinimum);
  const minYAxis = Math.floor(globalMinimum - diffMaxMin);
  const maxYAxis = Math.ceil(globalMaximum + diffMaxMin);

  return {
    minYAxis,
    maxYAxis,
    minValue: globalMinimum,
    maxValue: globalMaximum,
    diffMaxMin,
  };
};

export const getBoundariesHistoricData = (usedUnit, graphData) => {
  const minValue = graphData.reduce(
    (min, element) => (element.value < min ? element.value : min),
    graphData[0].value
  );
  const maxValue = graphData.reduce(
    (max, element) => (element.value > max ? element.value : max),
    graphData[0].value
  );

  const diffMaxMin = 0.2 * (Math.ceil(maxValue) - Math.floor(minValue));
  const maxYAxis = Math.ceil(maxValue + diffMaxMin);

  const minYAxis =
    usedUnit === '°C' || usedUnit === 'Tag des Jahres'
      ? Math.floor(minValue - diffMaxMin)
      : 0;

  return {
    minYAxis,
    maxYAxis,
    minValue,
    maxValue,
    diffMaxMin,
  };
};

export const getScale = (chartSize, minYAxis, maxYAxis, graphDomain) => {
  const xScale = scaleLinear()
    .domain(graphDomain)
    .range([0, chartSize.width]);

  const yScale = scaleLinear()
    .domain([minYAxis, maxYAxis])
    .range([chartSize.height, 0]);

  return {
    xScale,
    yScale,
  };
};

export const removeSvgElements = (svgWrapper) => {
  svgWrapper.selectAll('g').remove();
  svgWrapper.selectAll('path').remove();
  svgWrapper.selectAll('line').remove();
  svgWrapper.selectAll('text').remove();
  svgWrapper.selectAll('circle').remove();
};

export const rcpActive = (rcpString, rcpArray) => {
  const res = rcpArray.filter((element) => element.value === rcpString);
  return res.length > 0;
};
